module.exports = {"id":"221201","name":"Tim Leibold","rating":"72","photo":"./data/images/photos/3/221201.png","club":{"name":"1. FC Nuremberg","logo":"./data/images/clubs/1.FCNuremberg.png"},"positions":["DG","MG","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TimLeibold0.json
// module id = 4132
// module chunks = 0